<ng-container *ngIf="items$ | async as items">
  <div class="ref-carousel-wrapper">
    <div class="container" *ngIf="items.length > 0">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
        <div ngxSlickItem *ngFor="let item of items; let i = index" class="slide">
          <div class="item" *ngIf="item | async as data">
            <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
              <div class="prod-image">
                <div>
                  <cx-media
                    [container]="getImageRendition(data?.images?.PRIMARY)"
                    format="product"
                    [class.is-missing-fish]="businessType === 'fish'"
                  >
                  </cx-media>
                </div>
              </div>
              <div class="prod-body">
                <div class="prod-code">{{ data.code }}</div>
                <div class="prod-name" [innerHTML]="data.name"></div>
                <div
                  class="prod-price"
                  [class.has-erp-promo]="atLeastOneHasErpPromo && !showSrp"
                  [class.has-hybris-promo]="atLeastOneHasHybrisPromo && !showSrp"
                >
                  <ng-container>
                    <ng-template [ngIf]="!showSrp">
                      <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                      <span
                        class="p-price"
                        [class.erp-promo]="erpPromoValue(data?.code) && erpPromoValue(data?.code) !== ''"
                      >
                        <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(data.code); else dealerPriceReady">
                          <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                            <div class="spinner-shimano spinner-shimano-mr" *ngIf="hasDealerPrice">
                              <div></div>
                            </div>
                            <div
                              class="no-dealer-price no-dealer-price-alt test"
                              *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                            ></div>
                            <ng-template #noDealerPriceTooltip>
                              <app-tooltip-icon
                                *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled"
                                [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                                dealerPriceIconContainerClass="no-dealer-price-alt"
                                [uniqueClass]="data?.code"
                                placement="bottom-right"
                                [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                                [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                                [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                                [handleEvents]="tooltipIconConfig?.handleEvents"
                              ></app-tooltip-icon>
                            </ng-template>
                          </ng-container>
                        </div>
                        <ng-template #dealerPriceReady>
                          {{ dealerPrice(data.code)
                          }}<span class="gst-label" *ngIf="dealerPrice(data.code) && showGstExclusive$ | async">{{
                            'productCarousel.gstExclusive' | cxTranslate
                          }}</span>
                        </ng-template>
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="showSrp">
                      <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                      <span class="p-price"
                        >{{ data.srpPrice?.formattedValue
                        }}<span class="gst-label" *ngIf="data.srpPrice?.formattedValue && showGstInclusive$ | async">{{
                          'productCarousel.gstInclusive' | cxTranslate
                        }}</span></span
                      >
                    </ng-template>
                    <div class="break" *ngIf="!showSrp && isDesktop$ | async"></div>
                    <app-erp-promotional-text
                      *ngIf="dealerPrices && !showSrp && isAlternative$ | async"
                      class="promotional-text"
                      [dealerPriceData]="dealerPriceData(data?.code)"
                    ></app-erp-promotional-text>

                    <div class="break" *ngIf="atLeastOneHasHybrisPromo && !showSrp && isDesktop$ | async"></div>
                    <app-promotional-text
                      *ngIf="dealerPrices && !showSrp && isAlternative$ | async"
                      [productCode]="data?.code"
                      [product]="data"
                      [promotionLocation]="'CAROUSEL'"
                      [charactersLimit]="45"
                    ></app-promotional-text>

                    <div class="break"></div>
                  </ng-container>
                </div>
              </div>
            </a>
            <div class="prod-bottom container">
              <div class="row">
                <div class="col-sm-6">
                  <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
                    <mat-icon class="material-icons-sharp light">assignment</mat-icon>
                  </a>
                </div>
                <div class="col-sm-6">
                  <a tabindex="0" type="button" class="order-form" (click)="addToCart(data.code)">
                    <mat-icon class="material-icons-sharp light">note_add</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</ng-container>
